import React from 'react';
import { FaInfoCircle } from 'react-icons/fa';

interface StatCardProps {
  title: string;
  value: string | number;
  icon: React.ComponentType<{ size: number; className?: string }>;
  color: string;
  subtitle?: string;
  info?: string;
}

const StatCard: React.FC<StatCardProps> = ({ title, value, icon: Icon, color, subtitle, info }) => {
  return (
    <div className={`bg-white rounded-xl p-4 shadow-sm border-l-4 ${color} hover:shadow-md transition-shadow duration-200`}>
      <div className="flex items-center justify-between">
        <div className="flex-1">
          <div className="flex items-center gap-2 mb-1">
            <Icon size={16} className="text-gray-500" />
            <span className="text-sm font-medium text-gray-600">{title}</span>
            {info && (
              <FaInfoCircle size={14} className="text-gray-400 cursor-help" title={info} />
            )}
          </div>
          <div className="text-2xl font-bold text-gray-900">{value}</div>
          {subtitle && <div className="text-xs text-gray-500 mt-1">{subtitle}</div>}
        </div>
      </div>
    </div>
  );
};

export default StatCard;
